import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import stylesCoup from '../Shared/Css/VideosMy/VideosMy.module.css'

// const defaultyangsicImageSrc = '/empImg/image_placeholder.png'
const defaultEmpVideoSrc = '/empImg/video_placeholder.png';
const defaultEmpVideoExcelSrc = '/empImg/excel_placeholder.png';
const defaultEmpVideoPdflSrc = '/empImg/pdf_placeholder.png';
const defaultEmpVideoTxtlSrc = '/empImg/text_placeholder.png';
const defaultEmpVideo7zSrc = '/empImg/7z.png';
const defaultEmpVideohancomSrc = '/empImg/hancom.png';

const initialFieldValues = {
  yangsicId: 0,
  yangsicName: '',
  yangsicDesc: '',
  yangsicRegName: '',
  yangsicImgName: '',
  yangsicImageFile: null,
  yangsicImageType: '',
  yangsicImageSrc: defaultEmpVideoSrc,
};

function Yang(props) {
  const { addOrEdit, recordForEdit, setRecordForEdit, msg } = props;
  const [values, setValues] = useState(initialFieldValues);
  // const [imageType, setImageType] = useState(null);
  const [errors, setErrors] = useState({});
  const [vmsg, setVmsg] = useState(msg);

  //히스토리사용
  const history = useHistory();

  useEffect(() => {
    if (recordForEdit != null) {
      setValues(recordForEdit);
      setVmsg(null);
    }
  }, [recordForEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    //바이트계산 입력제안
    var byte = 0;
    for (var i = 0; i < value.length; ++i) {
      // 기본 한글 2바이트 처리
      value.charCodeAt(i) > 127 ? (byte += 2) : byte++;
    }
    //
    if (name === 'yangsicName') {
      if (byte <= 12) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('한글6글자 영문12자 입력이 가능합니다.');
      }
    } else if (name === 'yangsicDesc') {
      if (byte <= 22) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('한글12글자 영문22자 입력이 가능합니다.');
      }
    } else if (name === 'yangsicRegName') {
      if (byte <= 22) {
        setValues({
          ...values,
          [name]: value,
        });
      } else {
        alert('한글12글자 영문22자 입력이 가능합니다.');
      }
    }
    // console.log(byte);
    // console.log(values);
    // console.log(name);
  };

  const progressMag = () => {
    setVmsg('Uploading...');
    props.setProgress((prevState) => {
      return { ...prevState, started: true };
    });
  };

  const showPreview = (e) => {
    //  console.log(e.target.files[0].type)
    if (e.target.files && e.target.files[0]) {
      const yangsicImageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        if (
          e.target.files[0].type === 'image/png' ||
          e.target.files[0].type === 'image/bmp' ||
          e.target.files[0].type === 'image/jpeg' ||
          e.target.files[0].type === 'image/gif'
        ) {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'video/mp4') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else if (
          e.target.files[0].type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'application/pdf') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'text/plain') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'application/x-zip-compressed') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else if (e.target.files[0].type === 'application/haansofthwp') {
          progressMag();
          // setImageType(e.target.files[0].type);
          setValues({
            ...values,
            yangsicImageFile,
            yangsicImageType: e.target.files[0].type, //이미지타입
            yangsicImageSrc: x.target.result,
          });
        } else {
          alert('허용하지 않는 확장자 입니다.:' + e.target.files[0].type);
          cancelHandle();
        }
      };
      reader.readAsDataURL(yangsicImageFile);
    } else {
      setValues({
        ...values,
        yangsicImageFile: null,
        yangsicImageType: '',
        yangsicImageSrc: defaultEmpVideoSrc,
      });
    }
  };

  const validate = () => {
    let temp = {};
    temp.yangsicName = values.yangsciName === '' ? false : true;
    temp.ynagsicImageSrc = values.yangsicImageSrc === defaultEmpVideoSrc ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  //초기화
  const resetForm = (e) => {
    setValues(initialFieldValues);
    document.getElementById('image-uploader').value = null;
    setErrors({});
    setVmsg("")
  };

  //취소버튼
  const cancelHandle = () => {
    resetForm();
    props.setMsg("")
    setVmsg("")
    setRecordForEdit("")
    props.setProgress((prevState) => {
      return { ...prevState, started: false };
    });
  };

  const handlFormSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const formData = new FormData();
      formData.append('yangsicId', values.yangsicId);
      formData.append('yangsicName', values.yangsicName);
      formData.append('yangsicDesc', values.yangsicDesc);
      formData.append('yangsicRegName', values.yangsicRegName);
      formData.append('yangsicImgName', values.yangsicImgName);
      formData.append('yangsicImageFile', values.yangsicImageFile);
      formData.append('yangsicImageType', values.yangsicImageType);
      addOrEdit(formData, resetForm);
    } else {
      alert('입력항목을 확인하세요');
    }
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? ' invalidField' : '';

  return (
    <>
      <div className={`container-sm ${stylesCoup.textCenterEmp}`}>
        <p className="lead">파일[양식]등록 </p>
      </div>
      <form autoComplete="off" noValidate onSubmit={handlFormSubmit}>
        <div className="card">
          <div className={`emp-imges-card ${stylesCoup.empHidden}`}>
            {values.yangsicImageType === 'image/png' ? (
              <img
                src={values.yangsicImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'image/bmp' ? (
              <img
                src={values.yangsicImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'image/jpeg' ? (
              <img
                src={values.yangsicImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'image/gif' ? (
              <img
                src={values.yangsicImageSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'video/mp4' ? (
              <img
                src={defaultEmpVideoSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType ===
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? (
              <img
                src={defaultEmpVideoExcelSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'application/pdf' ? (
              <img
                src={defaultEmpVideoPdflSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'text/plain' ? (
              <img
                src={defaultEmpVideoTxtlSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'application/x-zip-compressed' ? (
              <img
                src={defaultEmpVideo7zSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : values.yangsicImageType === 'application/haansofthwp' ? (
              <img
                src={defaultEmpVideohancomSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            ) : (
              <img
                src={defaultEmpVideoSrc}
                className={`mx-auto d-block rounded ${stylesCoup.empDBlock}`}
                alt=""
              />
            )}
          </div>
          <div className={`card-body ${stylesCoup.cardBody}`}>
            <div className="form-group">
              <input
                type="file"
                accept="image/*, 
                        video/*,
                        application/vnd.ms-excel,
                        [doc] => application/msword,
                        application/vnd.ms-powerpoint,
                        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                        text/plain,
                        .pdf,
                        application/zip,
                        application/rar,
                        application/x-zip-compressed,
                        application/haansofthwp"
                className={'form-control-file' + applyErrorClass('yangsicImageSrc')}
                onChange={showPreview}
                id="image-uploader"
              />
            </div>
            <div className="form-group text-center">
              <div>{vmsg}</div>
              {props.progress.started && (
                <progress
                  className={stylesCoup.progressSize}
                  max="100"
                  value={props.progress.pc}
                />
              )}
            </div>
            <div className={stylesCoup.yangsicFormGroup}>
              <div className="form-group">
                <input
                  className={'form-control' + applyErrorClass('yangsicName')}
                  style={{ height: '30px' }}
                  placeholder="파일명"
                  name="yangsicName"
                  value={values.yangsicName}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className={stylesCoup.yangsicFormGroup}>
              <div className="form-group">
                <input
                  className={'form-control' + applyErrorClass('yangsicRegName')}
                  style={{ height: '30px' }}
                  placeholder="작성자"
                  name="yangsicRegName"
                  value={values.yangsicRegName}
                  onChange={handleInputChange}
                />
              </div>
              <div className={stylesCoup.yangsicFormGroup}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    style={{ height: '30px' }}
                    placeholder="파일설명기타"
                    name="yangsicDesc"
                    value={values.yangsicDesc}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
            <div className="form-group text-center">
              <button type="submit" className="btn btn-primary mt-3">
                실행
              </button>
              <button
                type="button"
                className="btn btn-info mt-3  ml-2 "
                onClick={cancelHandle}
              >
                취소
              </button>
              <button
                type="button"
                className="btn btn-warning mt-3  ml-2 "
                onClick={() => { history.goBack(); }}  //이게 더빠름
              // onClick={() => { window.location.href = '/home/index'; }}
              >
                나감
              </button>
            </div>
            <div style={{ textAlign: 'center' }}>{values.yangsicImgName}</div>
          </div>
        </div>
      </form>
    </>
  );
}
export default Yang;
